import { TransactionType } from '@app/shared/models/contracts/enums/shared-enums';
import { l } from '@locale/setupI18n';
import classNames from 'classnames';
import InstrumentTransactionRow from '../row-components/InstrumentTransactionRow';
import TransactionSummaryRow from '../row-components/TransactionSummaryRow';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import { OpmFirstLastWaterfallDictionaryDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import InstrumentDiscountFactorRow from '../row-components/InstrumentDiscountFactorRow';
import IterationLevelRow from '../row-components/IterationLevelRow';
import { SubSectionHeader } from '../row-components/SubSectionHeader';

interface InstrumentInfusionsCashFlowMovementsProps {
  titleColSpan: number;
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  selectedInstrument: string;
  waterfallIterations: number;
  hasInfusions: boolean;
}

const InstrumentInfusionsCashFlowMovements: React.FC<InstrumentInfusionsCashFlowMovementsProps> = ({
  titleColSpan,
  opmWaterfall,
  selectedYear,
  selectedInstrument,
  waterfallIterations,
  hasInfusions,
}: InstrumentInfusionsCashFlowMovementsProps) => {
  return (
    <>
      {hasInfusions && (
        <>
          <SubSectionHeader
            title={l('_Infusions')}
            className={classNames(styles['sub-section-header'])}
            titleColSpan={titleColSpan}
          />
          <InstrumentTransactionRow
            opmWaterfall={opmWaterfall}
            selectedYear={selectedYear}
            selectedInstrument={selectedInstrument}
            transactionType={TransactionType.Infusion}
            rowKeyPrefix="infusion"
          />
          <TransactionSummaryRow
            label="_TotalInfusion"
            valueKey="totalInfusion"
            opmWaterfall={opmWaterfall}
            selectedInstrument={selectedInstrument}
            selectedYear={selectedYear}
            waterfallIterations={waterfallIterations}
            isBold
          />
          <SubSectionHeader
            title={l('_DiscountFactor')}
            className={classNames(styles['sub-section-header'])}
            titleColSpan={titleColSpan}
          />
          <IterationLevelRow
            label="_RiskFreeRate"
            valueKey="riskFreeRatePc"
            opmWaterfall={opmWaterfall}
            selectedYear={selectedYear}
            waterfallIterations={waterfallIterations}
            isPercentage
            decimalPoint={2}
          />
          <InstrumentDiscountFactorRow
            opmWaterfall={opmWaterfall}
            selectedYear={selectedYear}
            selectedInstrument={selectedInstrument}
            transactionType={TransactionType.Infusion}
          />
          <TransactionSummaryRow
            label="_TotalPvOfInfusions"
            valueKey="infusionsFairValue"
            opmWaterfall={opmWaterfall}
            selectedInstrument={selectedInstrument}
            selectedYear={selectedYear}
            waterfallIterations={waterfallIterations}
            isBold
          />
        </>
      )}
    </>
  );
};

export default InstrumentInfusionsCashFlowMovements;
